import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"support"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M4.92893 4.92969C1.02369 8.83493 1.02369 15.1666 4.92893 19.0718L9.17157 14.8292C7.60948 13.2671 7.60948 10.7344 9.17157 9.17233L4.92893 4.92969Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M19.0711 19.0718C22.9763 15.1666 22.9763 8.83493 19.0711 4.92969L14.8284 9.17233C16.3905 10.7344 16.3905 13.2671 14.8284 14.8292L19.0711 19.0718Z"}}]},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M4.92871 19.0711C8.83396 22.9763 15.1656 22.9763 19.0708 19.0711L14.8282 14.8284C13.2661 16.3905 10.7335 16.3905 9.17135 14.8284L4.92871 19.0711Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M19.0708 4.92893C15.1656 1.02369 8.83395 1.02369 4.92871 4.92893L9.17135 9.17157C10.7335 7.60948 13.2661 7.60948 14.8282 9.17157L19.0708 4.92893Z"}}]},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M4.92871 19.0711C8.83396 22.9763 15.1656 22.9763 19.0708 19.0711L14.8282 14.8284C13.2661 16.3905 10.7335 16.3905 9.17135 14.8284L4.92871 19.0711Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19.0708 4.92893C15.1656 1.02369 8.83395 1.02369 4.92871 4.92893L9.17135 9.17157C10.7335 7.60948 13.2661 7.60948 14.8282 9.17157L19.0708 4.92893Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M4.92893 4.92969C1.02369 8.83493 1.02369 15.1666 4.92893 19.0718L9.17157 14.8292C7.60948 13.2671 7.60948 10.7344 9.17157 9.17233L4.92893 4.92969Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M19.0711 19.0718C22.9763 15.1666 22.9763 8.83493 19.0711 4.92969L14.8284 9.17233C16.3905 10.7344 16.3905 13.2671 14.8284 14.8292L19.0711 19.0718Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const Support = Vue.extend<IconProps>({
  name: 'SupportIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'support',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Support;
